<template>
  <el-dialog
    :title="title"
    :visible="isDialogVisible"
    :append-to-body="true"
    :show-close="true"
    custom-class="fifl-message-box"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :before-close="handleClickCloseButton"
  >
    <p
      class="booking-exist__message"
      v-html="message"
    />


    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        v-show="cancelButtonText"
        class="white"
        @click="handleClickCancelButton"
      >
        {{ cancelButtonText }}
      </el-button>
      <el-button
        v-show="confirmButtonText"
        class="gray"
        @click="handleClickConfirmButton"
      >
        {{ confirmButtonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import dateFns from 'date-fns';

export default {
  name: 'BookingExistWarningDialog',
  props: {
    hasSlot: {
      type: Boolean,
      default: false
    },
    confirmButtonText: {
      type: String,
      default: '확인'
    },
    cancelButtonText: {
      type: String,
      default: '취소'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String
    },
    title: {
      type: String
    },
    showNotice: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasCustomSlot() {
      return this.hasSlot;
    },
    isDialogVisible() {
      return this.dialogVisible;
    }
  },
  methods: {
    presentDate(dt) {
      return dateFns.format(dt, 'YYYY년 M월 D일 HH:mm');
    },
    presentPreviousBookingClass(date) {
      if (!this.isMarkingPreviousBooking) {
        return;
      }

      return {
        'booking-list__before': dateFns.isBefore(date, new Date())
      };
    },
    handleClickConfirmButton() {
      this.$emit('confirm');
    },
    handleClickCancelButton() {
      this.$emit('cancel');
    },
    handleClickCloseButton() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss">
.booking-exist__message {
  word-break: keep-all;
}

.booking-list-container {
  border-radius: 8px;
  background-color: #f2f2f2;
  height: 177px;
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;
  margin: 10px 0 0;

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  li {
    line-height: 25px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    &.booking-list__before {
      color: #224ba2;
    }

    .booking-list__date {
      display: inline-block;
      width: 143px;
      margin-right: 7px;
    }
  }
}
</style>
